(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };

      if (!this.elements.button || !this.elements.input || !this.elements.panel) return;

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString(),
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('#header-sticky');
      if (!this.header) return;

      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        return;
      }

      this.currentScrollTop = 0;
      this.throttledOnScroll = this.throttle(this.onScroll.bind(this), 100);

      this.createObserver();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.sentinel) this.sentinel.remove();
      if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
      window.removeEventListener('scroll', this.throttledOnScroll);
    }

    createObserver() {
      this.sentinel = document.querySelector('#sentinel');

      if (!this.sentinel) return;

      const observerOptions = {
        root: null, // viewport
        rootMargin: '0px',
        threshold: 0,
      };

      const onIntersection = (entries) => {
        entries.forEach((entry) => {
          const isScrolled = this.header.classList.contains('is-scrolled');

          if (!entry.isIntersecting && !isScrolled) {
            // Sentinel is off-screen, so we're scrolled down.
            this.header.classList.add('is-scrolled', 'shopify-section-header-sticky', 'shopify-section-header-hidden');
            this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop; // Initialize scroll position
            window.addEventListener('scroll', this.throttledOnScroll, { passive: true });
          } else if (entry.isIntersecting && isScrolled) {
            // Sentinel is visible, so we're back at the top.
            this.header.classList.remove(
              'is-scrolled',
              'shopify-section-header-sticky',
              'shopify-section-header-hidden',
              'animate',
            );
            window.removeEventListener('scroll', this.throttledOnScroll);
          }
        });
      };

      this.observer = new IntersectionObserver(onIntersection, observerOptions);
      this.observer.observe(this.sentinel);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.header.classList.contains('is-scrolled')) return;

      if (scrollTop > this.currentScrollTop) {
        // Scrolling down
        this.header.classList.add('shopify-section-header-hidden');
      } else {
        // Scrolling up
        this.header.classList.add('animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      this.currentScrollTop = scrollTop < 0 ? 0 : scrollTop;
    }

    throttle(fn, wait) {
      let inThrottle, lastFn, lastTime;
      return function () {
        const context = this,
          args = arguments;
        if (!inThrottle) {
          fn.apply(context, args);
          lastTime = Date.now();
          inThrottle = true;
        } else {
          clearTimeout(lastFn);
          lastFn = setTimeout(
            function () {
              if (Date.now() - lastTime >= wait) {
                fn.apply(context, args);
                lastTime = Date.now();
              }
            },
            Math.max(wait - (Date.now() - lastTime), 0),
          );
        }
      };
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const base_url = this.dataset.url
      this.url = base_url

      if(!base_url.includes("product_id")){
        // not on product page

        const viewedProductData = JSON.parse(localStorage.getItem("recentlyViewedProduct"));

        if(viewedProductData && viewedProductData[0]){
          this.url = base_url + `&product_id=${viewedProductData[0].id}`
        } else {
        this.url = base_url + `&product_id=${this.dataset.backup}`
        }

      }

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
